import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { BackButton } from "@industriousoffice/react-components";
import InvoiceTableCard from "@/components/InvoiceTableCard";
import useAccount from "@/hooks/useAccount";
import Layout from "@/components/Layout";
import { getFullPath } from "@/router/utils/getFullPath";
import { slugs } from "@/router/slugs";

export function Invoices() {
  const { accountId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("invoices");

  const { isLoadingAccount, account, name, invoices, isLoadingInvoices } =
    useAccount(accountId, { withInvoices: true });

  return (
    <Layout>
      <div className="mb-4">
        <BackButton onClick={() => navigate(-1)}>{t("Back")}</BackButton>
      </div>
      <span className="font-bold">
        {t("All Invoices", { name: name ?? "" })}
      </span>
      <div className="mt-5">
        <InvoiceTableCard
          invoices={invoices}
          isLoading={isLoadingInvoices || isLoadingAccount}
          description={account?.name ?? ""}
          currencyCode={account?.currencyCode ?? ""}
          withAction
          onAction={(invoiceId) =>
            navigate(getFullPath(slugs.invoice, { accountId, invoiceId }))
          }
          actionText={t("View Invoice")}
          footer={
            invoices.length ? (
              <div className="mx-4 my-2 text-sm text-grey-30">
                {t("invoices", { count: invoices.length })}
              </div>
            ) : null
          }
          emptyStateText={t("You currently don't have any invoices here")}
        />
      </div>
    </Layout>
  );
}
